/* eslint-disable camelcase */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable complexity */
import React, { Component } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import moment from 'moment';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Hotel from './hotel';
import './salida.css';
import featureAvailability from '../../commons/featureAvailability';
import commons from '../../commons/commons';

class Salida extends Component {
  static armarInfoAerolinea(transporte) {
    const elemento = '';

    if (transporte.img.length > 3) {
      return (<img src={transporte.img} title={transporte.nombreTransporte} alt={transporte.nombreTransporte} className='img-responsive' height='20px' width='85px' />);
    }
    if (transporte.nombreTransporte.length > 1) {
      return (
        <span>
          Viajando por:
          <span className='nombre-agencia'>
            {' '}
            {transporte.nombreTransporte}
          </span>
        </span>
      );
    }
    return elemento;
  }

  static getDate(value, valueFormat, returnFormat, returnedText = '', appendedText = '') {

    if (value === null || value === '0001-01-01T00:00:00' || value === undefined) {
      return returnedText;
    }
    if (returnFormat.toUpperCase().includes('H') && value.includes('00:00:00')) {
      return returnedText;
    }
    return `${moment(value, valueFormat).format(returnFormat)} ${appendedText}`;
  }

  constructor(props) {
    super(props);
    this.state = {
      isOpenHotel: false,
    };
    this.armarHoteles = this.armarHoteles.bind(this);
  }

  obtenerReferencia() {
    if (this.props.datos.referencia.interna) {
      if (this.props.datos.referencia.interna !== '') {
        return this.props.datos.referencia.interna;
      }
    }
    return this.props.datos.referencia.externa;
  }

  armarHoteles() {
    const { t } = this.props;
    const listaHoteles = [];
    if (this.props.hoteles && this.props.hoteles.length > 0) {
      for (let i = 0; i < this.props.hoteles.length; i++) {
        listaHoteles.push(
          <li className='item-hotel' key={i}>
            <Hotel datos={this.props.hoteles[i]} proveedorId={this.props.proveedorId} />
          </li>,
        );
      }
    }
    return (
      <div className='dropdown salida-hoteles relative'>
        <button
          type='button'
          onClick={this.toggleHotels}
          className='dropdown-toggle'
        >
          <i className='fa fa fa-chevron-down' />
          {' '}
          {t('packages.seeHotels')}
        </button>
        <ul className={`dropdown-menu ${this.state.isOpenHotel ? 'block' : 'hidden'}`}>
          {listaHoteles}
        </ul>
      </div>
    );
  }

  transporteElemento() {
    const { datos } = this.props;
    let img = '';
    let nombreTransporte = '';

    // Valida proveedor Allseasons
    if (datos.transporte.transporteAereo !== null) {
      img = datos.transporte.transporteAereo.imagen === null || datos.transporte.transporteAereo.imagen === undefined
        ? ''
        : datos.transporte.transporteAereo.imagen;
      nombreTransporte = datos.transporte.transporteAereo.nombreLineaAerea === null || datos.transporte.transporteAereo.nombreLineaAerea === undefined
        ? ''
        : datos.transporte.transporteAereo.nombreLineaAerea;
    }

    const transporte = {
      img,
      nombreTransporte,
    };

    return Salida.armarInfoAerolinea(transporte);
  }

  toggleHotels = () => this.setState((prev) => ({
    ...prev,
    isOpenHotel: !prev.isOpenHotel,
  }))

  render() {
    const { application, packagesDestination, salidas, indice, datos, cant_pasajeros, t } = this.props;
    // checking if country tax is apply in application country ID
    const countryTaxApply = featureAvailability.countryFeatureChecker(application.paisId, packagesDestination && packagesDestination.country_name, 'countryTax');
    // checking if price include the new country tax
    const countryTaxIsIncluded = commons.checkCountryTax(salidas[indice].precios.impuestoPais);

    const titleUrl = this.props.title.toLowerCase()
      .replace(/[-]/g, ' ')
      .replace(/[%]/g, ' ')
      .replace(/\s/g, '-')
      .replace(/[-][-][-]/g, '-')
      .replace(/[-][-]/g, '-')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/amp;/g, '');

    const ngrupo = this.props.salidas[0].hoteles[0] !== undefined ? this.props.salidas[0].hoteles[0].nroGrupo : null;
    const idOrigen = this.props.salidas[0].origenIata ? this.props.salidas[0].origenIata : '';
    // const origen = this.props.salidas[0].origen !== null ? this.props.salidas[0].origen : "";
    const nroComb = this.props.nroComb !== undefined ? this.props.nroComb : null;

    const redirectTag = isClient ? window.location.href : ''.indexOf('detalle') === -1
      ? `${process.env.RAZZLE_URL_PATH
      }/viajes/${isClient ? window.location.pathname : ''.split('/')[4]}/${titleUrl
      }?t=${this.obtenerReferencia()
      }&h=${this.props.distribucion
      }&p=${this.props.proveedorId
      }&s=${moment(this.props.datos.fechaSalida, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
      }&i=${this.props.idProducto
      }&m=${this.props.datos.precios.moneda
      }&d=${this.props.datos.destinoIata
      }&ngrupo=${ngrupo
      }&nroComb=${nroComb
      }&origen=${idOrigen}`
      : `${process.env.RAZZLE_URL_PATH
      }/viajes/${titleUrl
      }?t=${this.obtenerReferencia()
      }&h=${this.props.distribucion
      }&p=${this.props.proveedorId
      }&s=${moment(this.props.datos.fechaSalida, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
      }&i=${this.props.datos.idProducto
      }&m=${this.props.datos.precios.moneda
      }&d=${this.props.datos.idDestino
      }&ngrupo=${ngrupo
      }&nroComb=${nroComb
      }&origen=${idOrigen}`;

    // let cupos = this.props.datos.cupos;
    // cupos = cupos !== 0 ? `${ cupos } lugares` : "Consultar Disponibilidad";

    let salida;
    // moment.locale(t('requestForm.monthLang'));
    if (this.props.proveedorId === 3) {
      if (this.props.datos.uniqueOperationDate) {
        salida = moment(this.props.datos.operationDate, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY');
      } else {
        const fechaDesde = moment(this.props.datos.fechaSalida, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY');
        const fechaHasta = moment(this.props.datos.fechaLlegada, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY');
        salida = {
          fechaDesde,
          fechaHasta,
        };
      }
    } else {
      salida = moment(this.props.datos.fechaSalida, 'YYYY-MM-DDTHH:mm:ss').format('MM/DD/YYYY');
    }
    const currencyDefault = application.currency.code;

    const precioUnitario = commons.precioUnitario(datos.precios, cant_pasajeros, application.currency.code);

    const precio = (precioUnitario && commons.numberFixedToMoney(precioUnitario, 0)) || 'No disponible';

    const mobile = isClient ? window.innerWidth <= 768 : false;
    const formatoDia = mobile ? 'ddd D' : 'dddd D';
    const formatoMes = mobile ? 'MMM' : 'MMMM';

    const fechaDeSalida = salida.fechaDesde
      ? `${Salida.getDate(salida.fechaDesde, 'MM/DD/YYYY', formatoDia)} de ${Salida.getDate(salida.fechaDesde, 'MM/DD/YYYY', formatoMes)}`
      : `${Salida.getDate(salida, 'MM/DD/YYYY', formatoDia)} de ${Salida.getDate(salida, 'MM/DD/YYYY', formatoMes)}`;

    return (
      <a href={redirectTag} target='_blank' rel='noopener noreferrer'>
        <div className='sub-panel'>
          <div className='fecha-precio'>
            <div className=''>{fechaDeSalida}</div>
            <div className='contenedor-precio'>
              <span className='moneda'>
                {currencyDefault === 'USD' && this.props.datos.precios.precioNetoDolares != null
                  ? 'USD ' : 'ARS '}
              </span>
              { precio }
            </div>
          </div>
          <div className='hotel-transporte-btn-detalle'>
            <div className='contenedor-hoteles hidden sm:block'>{this.armarHoteles()}</div>

            {currencyDefault === 'USD' && countryTaxIsIncluded
              ? (
                <React.Fragment>
                  <span className='dib included'>impuesto pais no incluido</span>
                </React.Fragment>
              )
              : countryTaxApply && (
                <span className='country-tax'>
                  { countryTaxIsIncluded
                    ? (
                      <React.Fragment>
                        <span className='dib included'>Incluye&nbsp;</span>
                        <span className='dib included'>30% IMPUESTO PAIS</span>
                      </React.Fragment>
                    )
                    : (
                      <React.Fragment>
                        <span className='dib not-included'>No incluye&nbsp;</span>
                        <span className='dib not-included'>30% IMPUESTO PAIS</span>
                      </React.Fragment>
                    )}
                </span>
              )}

            <span
              role='button'
              className='button-salida-detalle color-dinamico'
              target='_blank'
              rel='noopener noreferrer'
            >
              {t('packages.buttonDetail')}
            </span>

          </div>
        </div>
      </a>
    );
  }
}
const mapStateToProps = (state) => ({
  application: state.applicationState,
  packagesDestination: state.packages.ciudadDestino,
});

export default connect(mapStateToProps, null)(withTranslation(['translations'])(Salida));

